export const menubarHeaderDesignToken = {
	padding: '0 0.75rem',
	background: '{primary.900}',
	border: {
		radius: '0',
		color: '{primary.900}',
	},
	item: {
		color: 'white',
		focus: {
			color: 'white',
			background: '{primary.700}',
		},
	},
	mobile: {
		button: {
			color: 'white',
			hover: {
				background: '{primary.700}',
				color: 'white',
			},
		},
	},
	submenu: {
		background: '{primary.900}',
	},
};
